//store/modules/auth.js

import axios from './axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
const state = {
  user: { user: null },
}
const getters = {
  isAuthenticated: (state) => !!state.user.user,
  StateUser: (state) => state.user.user,
}
const actions = {
  async userRegister({ commit }, u_details) {
    let response = await axios.post('/service/user-register', u_details)
    await commit('setResponse', response.data)
    return response.data
  },

  async newFundraiser({ commit }, f_details) {
    let response = await axios.post('/service/fundraiser/createFund', f_details)
    await commit('setResponse', response.data)
    return response.data
  },

  async forgotPass({ commit }, user) {
    let response = await axios.post('/forgot-password', user)
    await commit('setResponse', response.data)
    return response.data
  },

  async resetPassword({ commit }, password) {
    let response = await axios.post('/reset-password', password)
    await commit('setResponse', response.data)
    return response.data
  },

  async LogIn({ commit }, params) {
    let response = await axios.post('/fundraiser-login', params)
    await commit('setUser', response.data)
    if (response.data.status == 'success') {
      localStorage.setItem('authToken', response.data.user.sp_check)
      localStorage.setItem(
        'tokenExpiry',
        Date.now() + response.data.user.sp_time,
      )
    }
    return response.data
  },

  async LogOut({ commit }) {
    let user = { user: null }
    commit('logout', user)
  },
}
const mutations = {
  setResponse(state, response) {
    response = {}
    state.resp = response
  },
  setUser(state, response) {
    state.user = response
  },
  logout(state, user) {
    state.user = user
  },
}
export default {
  state,
  getters,
  actions,
  mutations,
}
